import moment from 'moment';
let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

const blockingTimeArray = [
    {
        value: '12:00 AM', label: `12:00 AM ${userlocation}`,
    },
    {
        value: '12:30 AM', label: `12:30 AM ${userlocation}`,
    },

    {
        value: '01:00 AM', label: `01:00 AM ${userlocation}`,
    },
    {
        value: '01:30 AM', label: `01:30 AM ${userlocation}`,
    },
    {
        value: '02:00 AM', label: `02:00 AM ${userlocation}`,
    },
    {
        value: '02:30 AM', label: `02:30 AM ${userlocation}`,
    },
    {
        value: '03:00 AM', label: `03:00 AM ${userlocation}`,
    },
    {
        value: '03:30 AM', label: `03:30 AM ${userlocation}`,
    },
    {
        value: '04:00 AM', label: `04:00 AM ${userlocation}`,
    },
    {
        value: '04:30 AM', label: `04:30 AM ${userlocation}`,
    },
    {
        value: '05:00 AM', label: `05:00 AM ${userlocation}`,
    },
    {
        value: '05:30 AM', label: `05:30 AM ${userlocation}`,
    },
    {
        value: '06:00 AM', label: `06:00 AM ${userlocation}`,
    },
    {
        value: '06:30 AM', label: `06:30 AM ${userlocation}`,
    },
    {
        value: '07:00 AM', label: `07:00 AM ${userlocation}`,
    },
    {
        value: '07:30 AM', label: `07:30 AM ${userlocation}`,
    },
    {
        value: '08:00 AM', label: `08:00 AM ${userlocation}`,
    },
    {
        value: '08:30 AM', label: `08:30 AM ${userlocation}`,
    },
    {
        value: '09:00 AM', label: `09:00 AM ${userlocation}`,
    },
    {
        value: '09:30 AM', label: `09:30 AM ${userlocation}`,
    },
    {
        value: '10:00 AM', label: `10:00 AM ${userlocation}`,
    },
    {
        value: '10:30 AM', label: `10:30 AM ${userlocation}`,
    },
    {
        value: '11:00 AM', label: `11:00 AM ${userlocation}`,
    },
    {
        value: '11:30 AM', label: `11:30 AM ${userlocation}`,
    },
    {
        value: '12:00 PM', label: `12:00 PM ${userlocation}`,
    },
    {
        value: '12:30 PM', label: `12:30 PM ${userlocation}`,
    },

    {
        value: '01:00 PM', label: `01:00 PM ${userlocation}`,
    },
    {
        value: '01:30 PM', label: `01:30 PM ${userlocation}`,
    },
    {
        value: '02:00 PM', label: `02:00 PM ${userlocation}`,
    },
    {
        value: '02:30 PM', label: `02:30 PM ${userlocation}`,
    },
    {
        value: '03:00 PM', label: `03:00 PM ${userlocation}`,
    },
    {
        value: '03:30 PM', label: `03:30 PM ${userlocation}`,
    },
    {
        value: '04:00 PM', label: `04:00 PM ${userlocation}`,
    },
    {
        value: '04:30 PM', label: `04:30 PM ${userlocation}`,
    },
    {
        value: '05:00 PM', label: `05:00 PM ${userlocation}`,
    },
    {
        value: '05:30 PM', label: `05:30 PM ${userlocation}`,
    },
    {
        value: '06:00 PM', label: `06:00 PM ${userlocation}`,
    },
    {
        value: '06:30 PM', label: `06:30 PM ${userlocation}`,
    },
    {
        value: '07:00 PM', label: `07:00 PM ${userlocation}`,
    },
    {
        value: '07:30 PM', label: `07:30 PM ${userlocation}`,
    },
    {
        value: '08:00 PM', label: `08:00 PM ${userlocation}`,
    },
    {
        value: '08:30 PM', label: `08:30 PM ${userlocation}`,
    },
    {
        value: '09:00 PM', label: `09:00 PM ${userlocation}`,
    },
    {
        value: '09:30 PM', label: `09:30 PM ${userlocation}`,
    },
    {
        value: '10:00 PM', label: `10:00 PM ${userlocation}`,
    },
    {
        value: '10:30 PM', label: `10:30 PM ${userlocation}`,
    },
    {
        value: '11:00 PM', label: `11:00 PM ${userlocation}`,
    },
    {
        value: '11:30 PM', label: `11:30 PM ${userlocation}`,
    },
    // {
    //     value: '12:00 AM', label: "12:00 AM",
    // },

]
const blockingMonth = [
    {
        value: 1, label: "January",
    },
    {
        value: 2, label: "February",
    },

    {
        value: 3, label: "March",
    },
    {
        value: 4, label: "April",
    },
    {
        value: 5, label: "May",
    },
    {
        value: 6, label: "June",
    },
    {
        value: 7, label: "July",
    },
    {
        value: 8, label: "August",
    },
    {
        value: 9, label: "September",
    },
    {
        value: 10, label: "October",
    },
    {
        value: 11, label: "November",
    },
    {
        value: 12, label: "December",
    }]

const DAYS = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
const REASONOFBLOCKING = [
    {
        value: '1', label: "Third-Party Appointment",
    }, {
        value: '2', label: 'Vacation',
    }, {
        value: '3', label: 'Break and Lunch times',
    }, {
        value: '4', label: 'Other',
    }
]
const appointmentModeItem = [
    {
        value: '1', label: "F2F",
    }, {
        value: '2', label: 'Online',
    }
]
const DAYSOFMONTH = [
    {
        value: 1, label: 1,
    },{
        value: 2, label: 2
    },{
        value: 3, label: 3
    },{
        value: 4, label: 4
    },{
        value: 5, label: 5
    },{
        value: 6, label: 6
    },{
        value: 7, label: 7
    },{
        value: 8, label: 8
    },{
        value: 9, label: 9
    },{
        value: 10, label: 10
    },{
        value: 11, label: 11
    },{
        value: 12, label: 12
    },{
        value: 13, label: 13
    },{
        value: 14, label: 14
    },{
        value: 15, label: 15
    },{
        value: 16, label: 16
    },{
        value: 17, label: 17
    },{
        value: 18, label: 18
    },{
        value: 19, label: 19
    },{
        value: 20, label: 20
    },{
        value: 21, label: 21
    },{
        value: 22, label: 22
    },{
        value: 23, label: 23
    },{
        value: 24, label: 24
    },{
        value: 25, label: 25
    },{
        value: 26, label: 26
    },{
        value: 27, label: 27
    },{
        value: 28, label: 28
    },{
        value: 29, label: 29
    },{
        value: 30, label: 30
    },{
        value: 31, label: 31
    }
]
const generateUTCStartEndTiming = (body) => {
    let { startTime, endTime } = body;
    let startAMPM = startTime.slice(-2);
    let endAMPM = endTime.slice(-2);
    let startHour = (startAMPM == 'AM') ? (parseInt(startTime.slice(0, startTime.lastIndexOf(":"))) == 12 ? 0 : parseInt(startTime.slice(0, startTime.lastIndexOf(":"))))  // setting 12 am as 00
        : (parseInt(startTime.slice(0, startTime.lastIndexOf(":"))) == 12 ? 12 : 12 + parseInt(startTime.slice(0, startTime.lastIndexOf(":")))); //setting time in 24 hours
    let startMinutes = parseInt(startTime.slice(startTime.lastIndexOf(":") + 1, startTime.lastIndexOf(" ")));
    let endHour = (endAMPM == 'AM') ? (parseInt(endTime.slice(0, endTime.lastIndexOf(":"))) == 12 ? 0 : parseInt(endTime.slice(0, endTime.lastIndexOf(":"))))
        : (parseInt(endTime.slice(0, endTime.lastIndexOf(":"))) == 12 ? 12 : 12 + parseInt(endTime.slice(0, endTime.lastIndexOf(":"))));
    let endMinutes = parseInt(endTime.slice(endTime.lastIndexOf(":") + 1, endTime.lastIndexOf(" ")));
    return {
        startHour,
        startMinutes,
        endHour,
        endMinutes
    }
}
export {
    blockingTimeArray,
    blockingMonth,
    DAYS,
    REASONOFBLOCKING,
    DAYSOFMONTH,
    appointmentModeItem,
    generateUTCStartEndTiming
} 